//
// ColorUtilities.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../moduleBuilder";
import ClosetObject from "../ClosetObject";
import "../lib";

var ColorUtilities = createModule("commons::ColorUtilities", [], ClosetObject, [
    ,
    ,
    ,
    ,
    ,
    {
        getHexStringFromColor: [7,10],
        getSASColorFromHexString: [10,7],
        getContrastingColor: [10,10,10],
        interpolateColor: [10,5,10,10],
    },
    ,
]);
export default ColorUtilities;
